import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import getClassicLink from './get-classic-link';
import getIconName from './get-icon-name';
import NavigationItemRecord from '../../../../../records/NavigationItemRecord';
import NavigationMenuColumnSectionRecord from '../../../../../records/NavigationMenuColumnSectionRecord';
export default function mapSubSectionGroupItems(subSectionGroup) {
  return subSectionGroup.reduce(function (groupItems, groupItem) {
    // iterate over 3rd level SECTIONS
    if (Array.isArray(groupItem.links)) {
      // iterate over 3rd level LINKS
      var groupLinks = groupItem.links.map(function (groupLink) {
        return new NavigationItemRecord(getClassicLink(groupLink));
      });
      groupItems.push(new NavigationMenuColumnSectionRecord({
        iconName: getIconName(groupItem),
        title: groupItem.label,
        links: groupLinks
      }));
    }

    return groupItems;
  }, []);
}